import type { CategoryTile } from "../../types/vtc";
import { useT } from "../../i18n";

interface CategoryTilesProps {
  categories: CategoryTile[];
  /** Makes found in each category (API); the static examples show until then. */
  brands?: Partial<Record<CategoryTile["id"], string[]>>;
  onSelect: (filter: string) => void;
}

export default function CategoryTiles({
  categories,
  brands = {},
  onSelect,
}: CategoryTilesProps) {
  const t = useT();
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
      <h2 className="m-0 mb-5 text-2xl font-medium sm:text-[28px]">
        {t.home.categoriesTitle}
      </h2>

      <div className="grid grid-cols-2 gap-2.5 sm:gap-3 lg:grid-cols-4">
        {categories.map((category) => (
          <button
            key={category.id}
            type="button"
            onClick={() => onSelect(category.filter)}
            className="flex cursor-pointer flex-col gap-1.5 rounded-lg border-0 bg-surface p-3.5 text-left sm:p-5 transition-colors hover:bg-surface-hover"
          >
            <span className="text-[15px] font-medium text-ink sm:text-[17px]">
              {t.home.categories[category.id].label}
            </span>
            <span className="line-clamp-2 text-xs text-muted sm:text-[13px]">
              {brands[category.id]?.length ? `${brands[category.id]!.join(", ")}…` : t.home.categories[category.id].sub}
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
